import React from "react";
import styles from "./OnboardingStrategy.module.css";
import { cleanLines, stripBoldTitle } from "./utils";

const parseExecutivePulse = (md = "") => {
  const lines = stripBoldTitle(cleanLines(md));
  let quote = "";
  const bodyLines = [];

  lines.forEach((line) => {
    if ((/^".*"$/.test(line) || /^'.*'$/.test(line)) && !quote) {
      quote = line.replace(/^"|"$/g, "").replace(/^'|'$/g, "");
    } else {
      bodyLines.push(line);
    }
  });

  return { quote: quote.trim(), body: bodyLines.join(" ").trim() };
};

const ExecutivePulse = ({ markdown = "" }) => {
  const { quote, body } = parseExecutivePulse(markdown);
  if (!quote && !body) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>Zeqi Onboarding Overview</h3>
      {quote ? (
        <div className={styles.quoteCard}>
          <p className={styles.quoteText}>"{quote}"</p>
        </div>
      ) : null}
      {body ? (
        <div className={styles.card}>
          <div className={styles.sectionHeader}>
            {/* <span>OV</span>
            <span className={styles.sectionLabel}>Overview</span> */}
          </div>
          <p className={styles.paragraph}>{body}</p>
        </div>
      ) : null}
    </div>
  );
};

export default ExecutivePulse;
